var map = {
	"./en/Faq.mdx": [
		83368,
		3368
	],
	"./en/Home.mdx": [
		31585,
		1159,
		7096,
		1585
	],
	"./en/PerClusterIntro.mdx": [
		42721,
		2721
	],
	"./en/PerCountryCasesIntro.mdx": [
		20970,
		970
	],
	"./en/PerCountryIntro/Switzerland.mdx": [
		93307,
		3307
	],
	"./en/PerCountryIntro/UnitedStates.mdx": [
		85895,
		5895
	],
	"./en/PerCountryIntro/World.mdx": [
		99972,
		9972
	],
	"./en/RegionBreakdownInfo.mdx": [
		45161,
		5161
	],
	"./en/SharedMutations.mdx": [
		70009,
		9
	],
	"./en/VariantsPageIntro.mdx": [
		1527,
		1159,
		7096,
		1527
	],
	"./en/clusters/20A.EU1.mdx": [
		63806,
		3806
	],
	"./en/clusters/20A.EU2.mdx": [
		27001,
		7001
	],
	"./en/clusters/20A.S.126A.mdx": [
		93982,
		3982
	],
	"./en/clusters/20B.S.732A.mdx": [
		70388,
		8007
	],
	"./en/clusters/20H.Beta.V2.mdx": [
		50620,
		620
	],
	"./en/clusters/20I.Alpha.V1.mdx": [
		20902,
		902
	],
	"./en/clusters/20J.Gamma.V3.mdx": [
		56072,
		6072
	],
	"./en/clusters/21A.B.mdx": [
		86144,
		6144
	],
	"./en/clusters/21A.Delta.mdx": [
		9104,
		9104
	],
	"./en/clusters/21B.Kappa.mdx": [
		93868,
		3868
	],
	"./en/clusters/21C.Epsilon.mdx": [
		13346,
		3346
	],
	"./en/clusters/21D.Eta.mdx": [
		81935,
		1935
	],
	"./en/clusters/21F.Iota.mdx": [
		82138,
		2138
	],
	"./en/clusters/21G.Lambda.mdx": [
		7941,
		7941
	],
	"./en/clusters/21H.Mu.mdx": [
		2859,
		2859
	],
	"./en/clusters/21I.Delta.mdx": [
		4088,
		4088
	],
	"./en/clusters/21J.Delta.mdx": [
		531,
		531
	],
	"./en/clusters/21K.Omicron.mdx": [
		29057,
		9057
	],
	"./en/clusters/21L.Omicron.mdx": [
		61038,
		1038
	],
	"./en/clusters/22A.Omicron.mdx": [
		39926,
		9926
	],
	"./en/clusters/22A22B_Spike.mdx": [
		55214,
		5214
	],
	"./en/clusters/22B.Omicron.mdx": [
		88309,
		8309
	],
	"./en/clusters/22C.Omicron.mdx": [
		32236,
		2236
	],
	"./en/clusters/22D.Omicron.mdx": [
		715,
		715
	],
	"./en/clusters/22E.Omicron.mdx": [
		17818,
		7818
	],
	"./en/clusters/22F.Omicron.mdx": [
		68585,
		8585
	],
	"./en/clusters/23A.Omicron.mdx": [
		13441,
		3441
	],
	"./en/clusters/23B.Omicron.mdx": [
		55730,
		5730
	],
	"./en/clusters/23C.Omicron.mdx": [
		59491,
		9491
	],
	"./en/clusters/23D.Omicron.mdx": [
		80356,
		356
	],
	"./en/clusters/23E.Omicron.mdx": [
		10413,
		413
	],
	"./en/clusters/23F.Omicron.mdx": [
		79982,
		9982
	],
	"./en/clusters/23G.Omicron.mdx": [
		19503,
		9503
	],
	"./en/clusters/23H.Omicron.mdx": [
		60464,
		464
	],
	"./en/clusters/23I.Omicron.mdx": [
		4953,
		4953
	],
	"./en/clusters/24A.Omicron.mdx": [
		39508,
		9508
	],
	"./en/clusters/24B.Omicron.mdx": [
		51999,
		1999
	],
	"./en/clusters/24C.Omicron.mdx": [
		46462,
		6462
	],
	"./en/clusters/ORF1a.S3675.mdx": [
		10015,
		15
	],
	"./en/clusters/OmicronHeader.mdx": [
		69482,
		9482
	],
	"./en/clusters/S.A626S.mdx": [
		33749,
		3749
	],
	"./en/clusters/S.D80Y.mdx": [
		64246,
		4246
	],
	"./en/clusters/S.E484.mdx": [
		18612,
		8612
	],
	"./en/clusters/S.H655.mdx": [
		61199,
		1199
	],
	"./en/clusters/S.H69-.mdx": [
		1355,
		1355
	],
	"./en/clusters/S.K417.mdx": [
		56618,
		6618
	],
	"./en/clusters/S.L18.mdx": [
		51470,
		1470
	],
	"./en/clusters/S.N439K.mdx": [
		47384,
		7384
	],
	"./en/clusters/S.N501.mdx": [
		82925,
		2925
	],
	"./en/clusters/S.P681.mdx": [
		93416,
		3416
	],
	"./en/clusters/S.Q677.mdx": [
		94716,
		4716
	],
	"./en/clusters/S.Q677H.Robin1.mdx": [
		22767,
		2767
	],
	"./en/clusters/S.Q677P.Pelican.mdx": [
		80756,
		756
	],
	"./en/clusters/S.S477.mdx": [
		70416,
		416
	],
	"./en/clusters/S.S98F.mdx": [
		32017,
		2017
	],
	"./en/clusters/S.V1122L.mdx": [
		61599,
		1599
	],
	"./en/clusters/S.Y144-.mdx": [
		95938,
		5938
	],
	"./en/clusters/S.Y453F.mdx": [
		2466,
		2466
	],
	"./en/clusters/VoCHeader.mdx": [
		5211,
		5211
	],
	"./zh/Faq.mdx": [
		17371,
		7371
	],
	"./zh/Home.mdx": [
		75796,
		1159,
		7096,
		5796
	],
	"./zh/PerClusterIntro.mdx": [
		4690,
		4690
	],
	"./zh/PerCountryCasesIntro.mdx": [
		22663,
		2663
	],
	"./zh/PerCountryIntro/Switzerland.mdx": [
		67152,
		7152
	],
	"./zh/PerCountryIntro/UnitedStates.mdx": [
		46682,
		6682
	],
	"./zh/PerCountryIntro/World.mdx": [
		90283,
		283
	],
	"./zh/RegionBreakdownInfo.mdx": [
		52154,
		2154
	],
	"./zh/SharedMutations.mdx": [
		69458,
		9458
	],
	"./zh/VariantsPageIntro.mdx": [
		33404,
		1159,
		7096,
		3404
	],
	"./zh/clusters/20A.EU1.mdx": [
		45639,
		5639
	],
	"./zh/clusters/20A.EU2.mdx": [
		81560,
		1560
	],
	"./zh/clusters/20A.S.126A.mdx": [
		74209,
		4209
	],
	"./zh/clusters/20B.S.732A.mdx": [
		11715,
		1715
	],
	"./zh/clusters/20H.Beta.V2.mdx": [
		52333,
		2333
	],
	"./zh/clusters/20I.Alpha.V1.mdx": [
		75077,
		5077
	],
	"./zh/clusters/20J.Gamma.V3.mdx": [
		14547,
		4547
	],
	"./zh/clusters/21A.B.mdx": [
		40897,
		897
	],
	"./zh/clusters/21A.Delta.mdx": [
		78885,
		8885
	],
	"./zh/clusters/21B.Kappa.mdx": [
		33121,
		3121
	],
	"./zh/clusters/21C.Epsilon.mdx": [
		46711,
		6711
	],
	"./zh/clusters/21D.Eta.mdx": [
		6846,
		6846
	],
	"./zh/clusters/21F.Iota.mdx": [
		96241,
		6241
	],
	"./zh/clusters/21G.Lambda.mdx": [
		47766,
		7766
	],
	"./zh/clusters/21H.Mu.mdx": [
		88316,
		8316
	],
	"./zh/clusters/21I.Delta.mdx": [
		9549,
		9549
	],
	"./zh/clusters/21J.Delta.mdx": [
		35870,
		5870
	],
	"./zh/clusters/21K.Omicron.mdx": [
		40516,
		516
	],
	"./zh/clusters/21L.Omicron.mdx": [
		85891,
		5891
	],
	"./zh/clusters/22A.Omicron.mdx": [
		36715,
		6715
	],
	"./zh/clusters/22B.Omicron.mdx": [
		86304,
		6304
	],
	"./zh/clusters/22D.Omicron.mdx": [
		22294,
		2294
	],
	"./zh/clusters/22E.Omicron.mdx": [
		52183,
		2183
	],
	"./zh/clusters/22F.Omicron.mdx": [
		54764,
		4764
	],
	"./zh/clusters/23A.Omicron.mdx": [
		22480,
		2480
	],
	"./zh/clusters/ORF1a.S3675.mdx": [
		88314,
		8314
	],
	"./zh/clusters/OmicronHeader.mdx": [
		29423,
		9423
	],
	"./zh/clusters/S.A626S.mdx": [
		96144,
		3763
	],
	"./zh/clusters/S.D80Y.mdx": [
		13017,
		3017
	],
	"./zh/clusters/S.E484.mdx": [
		72499,
		2499
	],
	"./zh/clusters/S.H655.mdx": [
		87088,
		7088
	],
	"./zh/clusters/S.H69-.mdx": [
		9692,
		9692
	],
	"./zh/clusters/S.K417.mdx": [
		94009,
		4009
	],
	"./zh/clusters/S.L18.mdx": [
		98071,
		8071
	],
	"./zh/clusters/S.N439K.mdx": [
		82257,
		2257
	],
	"./zh/clusters/S.N501.mdx": [
		77142,
		7142
	],
	"./zh/clusters/S.P681.mdx": [
		52759,
		2759
	],
	"./zh/clusters/S.Q677.mdx": [
		38407,
		8407
	],
	"./zh/clusters/S.Q677H.Robin1.mdx": [
		70808,
		808
	],
	"./zh/clusters/S.Q677P.Pelican.mdx": [
		3357,
		3357
	],
	"./zh/clusters/S.S477.mdx": [
		62399,
		4780
	],
	"./zh/clusters/S.S98F.mdx": [
		15010,
		5010
	],
	"./zh/clusters/S.V1122L.mdx": [
		30760,
		760
	],
	"./zh/clusters/S.Y144-.mdx": [
		11011,
		1011
	],
	"./zh/clusters/S.Y453F.mdx": [
		25295,
		5295
	],
	"./zh/clusters/VoCHeader.mdx": [
		97562,
		7562
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61769;
module.exports = webpackAsyncContext;